import type { ApiResponse } from '@/api/envelope';
import { turboproFetch } from '@/api/turbopro';
import { consultaDoContribuinte } from './consultaDoContribuinte';

/**
 * O XML da NFS-e pela rota do módulo de NFS-e (SPEC-011, §3, item 6): ela confere o vínculo do gestor e devolve o
 * arquivo como anexo. Substitui o link temporário genérico, que assinava qualquer chave e abria o XML numa aba.
 * Recusa volta no envelope JSON (HTTP 200 com `resultado: false`): é pelo tipo do conteúdo que se distingue.
 */
export async function baixarXmlNfse(
  chaveAcessoDoc: string,
  cnpjContribuinte?: string | null
): Promise<{ arquivo: Blob; nome: string }> {
  const resposta = await turboproFetch(
    `Documento/XmlNFS/${encodeURIComponent(chaveAcessoDoc)}${consultaDoContribuinte(cnpjContribuinte)}`
  );
  const tipo = resposta.headers.get('Content-Type') ?? '';

  if (!resposta.ok || tipo.includes('application/json')) {
    let mensagem = 'Não foi possível baixar o XML desta NFS-e.';
    try {
      const corpo = (await resposta.json()) as ApiResponse<unknown>;
      mensagem = corpo?.status?.mensagem || mensagem;
    } catch {
      /* corpo não-JSON: segue com a mensagem padrão */
    }
    throw new Error(mensagem);
  }

  return { arquivo: await resposta.blob(), nome: `${chaveAcessoDoc}.xml` };
}
